const Apple = () => {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.9933 8.67102C19.8609 8.77228 17.523 10.0707 17.523 12.9577C17.523 16.297 20.4979 17.4784 20.587 17.5076C20.5733 17.5797 20.1143 19.1256 19.0184 20.7007C18.0413 22.0869 17.0207 23.4707 15.4682 23.4707C13.9157 23.4707 13.5161 22.5819 11.7238 22.5819C9.97725 22.5819 9.35624 23.5 7.93614 23.5C6.51603 23.5 5.52515 22.2174 4.38587 20.6422C3.06622 18.7925 2 15.919 2 13.1917C2 8.81728 4.88588 6.4973 7.72609 6.4973C9.23524 6.4973 10.4932 7.4739 11.4407 7.4739C12.3426 7.4739 13.749 6.43879 15.4659 6.43879C16.1166 6.43879 18.4545 6.4973 19.9933 8.67102ZM14.6508 4.58686C15.3609 3.75653 15.8632 2.60441 15.8632 1.4523C15.8632 1.29253 15.8495 1.13051 15.8198 1C14.6645 1.04275 13.2901 1.75833 12.4613 2.70567C11.8106 3.43474 11.2033 4.58686 11.2033 5.75473C11.2033 5.93024 11.233 6.10576 11.2467 6.16202C11.3197 6.17552 11.4385 6.19127 11.5572 6.19127C12.5937 6.19127 13.8974 5.5072 14.6508 4.58686Z"
                    fill="black"
                />
            </svg>
        </svg>
    );
};

export default Apple;
